import { auth } from "../typings/auth";
import { STATE } from "../thor.const";
import { LokiMainController } from "./loki.main.controller";
import { LokiOrganizationsController } from "./organizations/organizations.controller";
import { LokiSalesController } from "./sales/loki-sales.controller";
import { LokiItemsController } from "./items/loki-items.controller";
import { Enums } from "../thor.enums";

export class LokiRoutes {
    public static $inject: string[] = [
        "$stateProvider"
    ];

    constructor(
        $stateProvider: angular.ui.IStateProvider
    ) {
        $stateProvider
            .state(STATE.LOKI.ABSTRACT, {
                abstract: true,
                url: "/loki",
                template: require("./loki.main.html"),
                controller: LokiMainController,
                controllerAs: "mainCtrl",
                data: {
                    containerClass: "loki",
                    title: "loki"
                },
                resolve: {
                    // initUser is injected here to ensure that it's resolved before resolving acl permission
                    checkAcl: ["aclService", "initUser", aclService => aclService.isStateAllowed(auth.AclAccess.Loki)],
                    setLangFr: [
                        "$translate",
                        ($translate: ng.translate.ITranslateService) => $translate.use(Enums.Locale.Fr)
                    ]
                },
                onEnter: () => {
                    if (sessionStorage.getItem("organizationId")) {
                        sessionStorage.removeItem("organizationId");
                    }
                }
            })
            .state(STATE.LOKI.ORGANIZATIONS, {
                url: "",
                template: require("./organizations/organizations.html"),
                controller: LokiOrganizationsController,
                controllerAs: "organizationsCtrl",
                data: {
                    advancedSearchPartial: "organizations"
                }
            })
            .state(STATE.LOKI.SALES.PAST, {
                url: "/ventes-passees",
                template: require("./sales/loki-sales.html"),
                controller: LokiSalesController,
                controllerAs: "lokiSalesCtrl",
                data: {
                    context: "past",
                    advancedSearchPartial: "sales"
                }
            })
            .state(STATE.LOKI.SALES.FUTURE, {
                url: "/ventes-futures",
                template: require("./sales/loki-sales.html"),
                controller: LokiSalesController,
                controllerAs: "lokiSalesCtrl",
                data: {
                    context: "future",
                    advancedSearchPartial: "sales"
                }
            })
            .state(STATE.LOKI.ITEMS.PAST, {
                url: "/lots-passes",
                template: require("./items/loki-items.html"),
                controller: LokiItemsController,
                controllerAs: "lokiItemsCtrl",
                data: {
                    context: "past",
                    advancedSearchPartial: "items"
                }
            })
            .state(STATE.LOKI.ITEMS.FUTURE, {
                url: "/lots-futurs",
                template: require("./items/loki-items.html"),
                controller: LokiItemsController,
                controllerAs: "lokiItemsCtrl",
                data: {
                    context: "future",
                    advancedSearchPartial: "items"
                }
            });
    }
}
